/**
 * @generated SignedSource<<d2ccaf4e3563fd0d9e767a5cc20ccab0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetUserTeamContextInput = {
  teamId?: any | null | undefined;
};
export type useTeamSelectionSetUserTeamContextMutation$variables = {
  input: SetUserTeamContextInput;
};
export type useTeamSelectionSetUserTeamContextMutation$data = {
  readonly setUserTeamContext: {
    readonly error: string | null | undefined;
    readonly userTeamContext: {
      readonly id: any;
      readonly team: {
        readonly id: any;
        readonly name: string;
      };
    } | null | undefined;
  };
};
export type useTeamSelectionSetUserTeamContextMutation = {
  response: useTeamSelectionSetUserTeamContextMutation$data;
  variables: useTeamSelectionSetUserTeamContextMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetUserTeamContextPayload",
    "kind": "LinkedField",
    "name": "setUserTeamContext",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUserTeamContext",
        "kind": "LinkedField",
        "name": "userTeamContext",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLTeam",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTeamSelectionSetUserTeamContextMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTeamSelectionSetUserTeamContextMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4db433f047fa265a966b978667491cf1",
    "id": null,
    "metadata": {},
    "name": "useTeamSelectionSetUserTeamContextMutation",
    "operationKind": "mutation",
    "text": "mutation useTeamSelectionSetUserTeamContextMutation(\n  $input: SetUserTeamContextInput!\n) {\n  setUserTeamContext(input: $input) {\n    userTeamContext {\n      id\n      team {\n        id\n        name\n      }\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "caf3e93e46bedb678716ef43ff9bdb0c";

export default node;
